import React, { HTMLProps } from 'react'
import { cn } from 'ui'

export const BindingField = React.forwardRef<
  HTMLButtonElement,
  React.HTMLProps<HTMLButtonElement>
>(({ className, ...props }, ref) => {
  return (
    <button
      {...props}
      className={cn('bg-primary text-white w-full h-full', className)}
      ref={ref}
    />
  )
})
